import React, { useEffect, useState } from "react";
import styled from "styled-components";
import UserBookingListing from "./UserBookingListing";
import { getAllUserBookings } from "../../redux/actions/mindfulness";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

// Styled Components

// Styled Components
const Container = styled.div`
  box-sizing: border-box;
  padding: 20px;
  width: 80%;
  margin: 0 auto;
  font-family: Montserrat;
  margin-top: 7.5rem;
  font-weight: 400;
  border-radius: 15px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
  background: rgba(255, 255, 255, 1);
`;

const Header = styled.div`
  margin-bottom: 20px;
  h1 {
    font-size: 1.875rem;
    font-weight: 400;
    color: #333;
    margin-bottom: 4px;
  }
  p {
    color: #6a6a6a;
    font-size: 1rem;
  }
`;

const TopContainer = styled.div`
  padding: 1.5rem;
  box-sizing: border-box;
  border: 1px solid rgba(229, 231, 235, 1);
  border-radius: 14px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1),
    0px 1px 2px -1px rgba(0, 0, 0, 0.1);
  background: rgba(255, 255, 255, 1);
`;

const TabsContainer = styled.div`
  border-bottom: 1px solid #ddd;
  margin-bottom: 20px;
  position: relative;
  width: 100%;
`;

const Tabs = styled.div`
  display: flex;
  gap: 30px;
  width: 100%;
`;

const Tab = styled.div`
  padding: 18px 0;
  position: relative;
  color: ${(props) => (props.active ? "#FB2C36" : "#706c6c")};
  font-weight: ${(props) => (props.active ? 500 : 400)};
  font-size: 1rem;
  width: 100%;
  text-align: center;
  cursor: pointer;

  &::after {
    content: "";
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: ${(props) => (props.active ? "#e53935" : "transparent")};
    transition: all 0.3s ease;
  }

  &:hover {
    color: ${(props) => (props.active ? "#e53935" : "#333")};
  }
`;

const SessionCount = styled.div`
  color: #4a5565;
  font-size: 14px;
  font-weight: 400;
  margin: 20px 0;
`;

const BookingsContainer = styled.div`
  min-height: 20rem;
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: #706c6c;

  p {
    font-size: 1.1rem;
    margin-top: 10px;
  }
`;

const BookingItem = styled.div`
  border: 1px solid #eee;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 15px;
  background: #f9fafb;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    transform: translateY(-1px);
  }

  h3 {
    color: #333;
    margin: 0 0 8px;
    font-size: 1.2rem;
  }

  .details {
    display: flex;
    justify-content: space-between;
    color: #6a6a6a;
    font-size: 0.95rem;
    margin-top: 10px;
  }

  .status {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 0.85rem;
    font-weight: 500;
    margin-top: 8px;

    &.upcoming {
      background: #e3f2fd;
      color: #1976d2;
    }

    &.completed {
      background: #e8f5e9;
      color: #388e3c;
    }
  }
`;

function AllUserBookings() {
  const [activeTab, setActiveTab] = useState("upcoming");
  const [isLoading, setIsLoading] = useState(true);

  const dispatch = useDispatch();

  const userBookings = useSelector(
    (state) => state?.mindfulness.userBookings,
  );
  // const userBookings = testData;

  // Use userBookings from Redux state or fallback to testData
  const bookingData = userBookings || testData;

  const upcomingBookings = bookingData?.upcoming_bookings || [];
  const completedBookings = bookingData?.past_bookings || [];

  // Get current bookings based on active tab
  const currentBookings =
    activeTab === "upcoming" ? upcomingBookings : completedBookings;
  const bookingCount = currentBookings.length;

  console.log("userBookings", userBookings);

  useEffect(() => {
    const fetchBookings = async () => {
      await dispatch(getAllUserBookings());
      setIsLoading(false);
    };
    fetchBookings();
  }, [dispatch]);

  return (
    <Container>
      <Header>
        <h1>My Bookings</h1>
        <p>Find all your sessions here</p>
      </Header>

      <TopContainer>
        <TabsContainer>
          <Tabs>
            <Tab
              active={activeTab === "upcoming"}
              onClick={() => setActiveTab("upcoming")}
            >
              Upcoming
            </Tab>
            <Tab
              active={activeTab === "completed"}
              onClick={() => setActiveTab("completed")}
            >
              Completed
            </Tab>
          </Tabs>
        </TabsContainer>
      </TopContainer>

      <SessionCount>
        {bookingCount} {activeTab} booking{bookingCount !== 1 ? "s" : ""}
      </SessionCount>

      <BookingsContainer>
        {bookingCount > 0 ? (
          <UserBookingListing data={bookingData} activeTab={activeTab} />
        ) : (
          <EmptyState>
            <h2>No {activeTab} bookings</h2>
            <p>
              {activeTab === "upcoming"
                ? "You don't have any upcoming sessions scheduled"
                : "You haven't completed any sessions yet"}
            </p>
          </EmptyState>
        )}
      </BookingsContainer>
    </Container>
  );
}

export default AllUserBookings;

const testData = {
  upcoming_bookings: [
    {
      id: 8,
      user_name: "Katherine Pryde",
      session_name: "Therapy 101",
      creator_name: "Prof. charles xavier",
      amount: 0,
      creator_profile_pic:
        "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/dpImages/389-prof-x-p8p8em.jpg",
      type: "call",
      start_time: "2026-02-12T12:00:00Z",
      duration: 60,
      end_time: "2026-02-12T13:00:00Z",
      status: "pending",
      notes: "",
      transaction: null,
      is_active: true,
      timestamp: "2026-02-06T06:55:50.127555Z",
      utimestamp: "2026-02-06T06:55:50.127567Z",
      creator_session: 17,
      user: 391,
    },
    {
      id: 7,
      user_name: "Katherine Pryde",
      session_name: "Therapy 101",
      creator_name: "Prof. charles xavier",
      amount: 0,
      creator_profile_pic:
        "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/dpImages/389-prof-x-p8p8em.jpg",
      type: "call",
      start_time: "2026-02-11T12:00:00Z",
      duration: 60,
      end_time: "2026-02-11T13:00:00Z",
      status: "pending",
      notes: "",
      transaction: null,
      is_active: true,
      timestamp: "2026-02-06T05:57:17.328126Z",
      utimestamp: "2026-02-06T05:57:17.328138Z",
      creator_session: 17,
      user: 391,
    },
    {
      id: 9,
      user_name: "Katherine Pryde",
      session_name: "Therapy 101",
      creator_name: "Prof. charles xavier",
      amount: 0,
      creator_profile_pic:
        "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/dpImages/389-prof-x-p8p8em.jpg",
      type: "call",
      start_time: "2026-02-11T11:00:00Z",
      duration: 60,
      end_time: "2026-02-11T12:00:00Z",
      status: "pending",
      notes: "",
      transaction: null,
      is_active: true,
      timestamp: "2026-02-06T06:57:25.562656Z",
      utimestamp: "2026-02-06T06:57:25.562668Z",
      creator_session: 17,
      user: 391,
    },
    {
      id: 6,
      user_name: "Katherine Pryde",
      session_name: "Therapy 101",
      creator_name: "Prof. charles xavier",
      amount: 0,
      creator_profile_pic:
        "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/dpImages/389-prof-x-p8p8em.jpg",
      type: "call",
      start_time: "2026-02-10T10:00:00Z",
      duration: 60,
      end_time: "2026-02-10T11:00:00Z",
      status: "pending",
      notes: "",
      transaction: null,
      is_active: true,
      timestamp: "2026-02-05T14:11:07.454568Z",
      utimestamp: "2026-02-05T14:11:07.454582Z",
      creator_session: 17,
      user: 391,
    },
  ],
  past_bookings: [
    {
      id: 5,
      user_name: "Katherine Pryde",
      session_name: "Evening Mindfulness and Breathwork",
      creator_name: "Prof. charles xavier",
      amount: 0,
      creator_profile_pic:
        "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/dpImages/389-prof-x-p8p8em.jpg",
      type: "call",
      start_time: "2026-02-05T09:00:00Z",
      duration: 60,
      end_time: "2026-02-05T10:00:00Z",
      status: "pending",
      notes: "",
      transaction: null,
      is_active: true,
      timestamp: "2026-02-03T07:05:57.879576Z",
      utimestamp: "2026-02-03T07:05:57.879588Z",
      creator_session: 3,
      user: 391,
    },
    {
      id: 1,
      user_name: "Katherine Pryde",
      session_name: "Calm Focus Meditation Session",
      creator_name: "Prof. charles xavier",
      amount: 0,
      creator_profile_pic:
        "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/dpImages/389-prof-x-p8p8em.jpg",
      type: "call",
      start_time: "2026-02-02T09:00:00Z",
      duration: 45,
      end_time: "2026-02-02T09:45:00Z",
      status: "pending",
      notes: "",
      transaction: null,
      is_active: true,
      timestamp: "2026-02-02T07:30:04.609393Z",
      utimestamp: "2026-02-02T07:30:04.609409Z",
      creator_session: 2,
      user: 391,
    },
  ],
  total_bookings: [
    {
      id: 8,
      user_name: "Katherine Pryde",
      session_name: "Therapy 101",
      creator_name: "Prof. charles xavier",
      amount: 0,
      creator_profile_pic:
        "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/dpImages/389-prof-x-p8p8em.jpg",
      type: "call",
      start_time: "2026-02-12T12:00:00Z",
      duration: 60,
      end_time: "2026-02-12T13:00:00Z",
      status: "pending",
      notes: "",
      transaction: null,
      is_active: true,
      timestamp: "2026-02-06T06:55:50.127555Z",
      utimestamp: "2026-02-06T06:55:50.127567Z",
      creator_session: 17,
      user: 391,
    },
    {
      id: 7,
      user_name: "Katherine Pryde",
      session_name: "Therapy 101",
      creator_name: "Prof. charles xavier",
      amount: 0,
      creator_profile_pic:
        "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/dpImages/389-prof-x-p8p8em.jpg",
      type: "call",
      start_time: "2026-02-11T12:00:00Z",
      duration: 60,
      end_time: "2026-02-11T13:00:00Z",
      status: "pending",
      notes: "",
      transaction: null,
      is_active: true,
      timestamp: "2026-02-06T05:57:17.328126Z",
      utimestamp: "2026-02-06T05:57:17.328138Z",
      creator_session: 17,
      user: 391,
    },
    {
      id: 9,
      user_name: "Katherine Pryde",
      session_name: "Therapy 101",
      creator_name: "Prof. charles xavier",
      amount: 0,
      creator_profile_pic:
        "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/dpImages/389-prof-x-p8p8em.jpg",
      type: "call",
      start_time: "2026-02-11T11:00:00Z",
      duration: 60,
      end_time: "2026-02-11T12:00:00Z",
      status: "pending",
      notes: "",
      transaction: null,
      is_active: true,
      timestamp: "2026-02-06T06:57:25.562656Z",
      utimestamp: "2026-02-06T06:57:25.562668Z",
      creator_session: 17,
      user: 391,
    },
    {
      id: 6,
      user_name: "Katherine Pryde",
      session_name: "Therapy 101",
      creator_name: "Prof. charles xavier",
      amount: 0,
      creator_profile_pic:
        "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/dpImages/389-prof-x-p8p8em.jpg",
      type: "call",
      start_time: "2026-02-10T10:00:00Z",
      duration: 60,
      end_time: "2026-02-10T11:00:00Z",
      status: "pending",
      notes: "",
      transaction: null,
      is_active: true,
      timestamp: "2026-02-05T14:11:07.454568Z",
      utimestamp: "2026-02-05T14:11:07.454582Z",
      creator_session: 17,
      user: 391,
    },
    {
      id: 5,
      user_name: "Katherine Pryde",
      session_name: "Evening Mindfulness and Breathwork",
      creator_name: "Prof. charles xavier",
      amount: 0,
      creator_profile_pic:
        "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/dpImages/389-prof-x-p8p8em.jpg",
      type: "call",
      start_time: "2026-02-05T09:00:00Z",
      duration: 60,
      end_time: "2026-02-05T10:00:00Z",
      status: "pending",
      notes: "",
      transaction: null,
      is_active: true,
      timestamp: "2026-02-03T07:05:57.879576Z",
      utimestamp: "2026-02-03T07:05:57.879588Z",
      creator_session: 3,
      user: 391,
    },
    {
      id: 1,
      user_name: "Katherine Pryde",
      session_name: "Calm Focus Meditation Session",
      creator_name: "Prof. charles xavier",
      amount: 0,
      creator_profile_pic:
        "https://chalkmates-backend-assets.s3.amazonaws.com/media/uploads/profile/389/dpImages/389-prof-x-p8p8em.jpg",
      type: "call",
      start_time: "2026-02-02T09:00:00Z",
      duration: 45,
      end_time: "2026-02-02T09:45:00Z",
      status: "pending",
      notes: "",
      transaction: null,
      is_active: true,
      timestamp: "2026-02-02T07:30:04.609393Z",
      utimestamp: "2026-02-02T07:30:04.609409Z",
      creator_session: 2,
      user: 391,
    },
  ],
};
